"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RequestTabContent;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@synerg/react-components");
var _agGridReact = require("ag-grid-react");
require("ag-grid-community/dist/styles/ag-theme-alpine.css");
require("ag-grid-community/dist/styles/ag-grid.css");
var _grid = require("../../shared/grid");
var _copyButton = _interopRequireDefault(require("../../common/copyButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function RequestTabContent(_ref) {
  var onRequestSectionTabChange = _ref.onRequestSectionTabChange,
    headersTabValue = _ref.headersTabValue,
    requestSectionTabValue = _ref.requestSectionTabValue,
    parametersTabValue = _ref.parametersTabValue,
    previewTabValue = _ref.previewTabValue,
    gridApiRef = _ref.gridApiRef,
    headersTabRowData = _ref.headersTabRowData,
    headersTabColumnDefs = _ref.headersTabColumnDefs,
    gridParamApiRef = _ref.gridParamApiRef,
    parametersTabOptionalRowData = _ref.parametersTabOptionalRowData,
    parametersTabRequiredRowData = _ref.parametersTabRequiredRowData,
    parametersTabColumnDefs = _ref.parametersTabColumnDefs,
    previewTabData = _ref.previewTabData,
    previewTabDataFormatted = _ref.previewTabDataFormatted,
    defaultColDef = _ref.defaultColDef,
    customClassNamesRequestTab = _ref.customClassNamesRequestTab;
  var handleEmptyState = function handleEmptyState(tabValue, tabRowData, textHeading) {
    var customClassNamesRequestTabParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return tabValue === requestSectionTabValue && (tabRowData.length === 0 || tabRowData === '') ? /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(customClassNamesRequestTabParam ? customClassNamesRequestTabParam : 'mt-24 flex flex-col items-center mb-16')
    }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfSpotIllustration, {
      illustrationName: "empty-skills",
      size: "md"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(customClassNamesRequestTabParam ? 'mt-4 text-center' : 'mt-10 text-center')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-2xl font-bold leading-xs tracking-xs text-heading-04 text-tertiary"
    }, "No ", textHeading, " provided"))) : /*#__PURE__*/_react.default.createElement("div", null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-4 mt-3 md:col-span-12"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-05 font-black mb-1 -mt-4"
  }, "Request"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTabGroup, {
    className: "mb-4",
    size: "small",
    onSdfChange: function onSdfChange(event) {
      return onRequestSectionTabChange(event.detail.value);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    className: "size-small",
    value: headersTabValue,
    active: headersTabValue === requestSectionTabValue
  }, "Headers"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    className: "size-small",
    value: parametersTabValue,
    active: parametersTabValue === requestSectionTabValue
  }, "Parameters"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    className: "size-small",
    value: previewTabValue,
    active: previewTabValue === requestSectionTabValue
  }, "cURL"))), /*#__PURE__*/_react.default.createElement("div", null, handleEmptyState(headersTabValue, headersTabRowData, 'headers')), headersTabValue === requestSectionTabValue && headersTabRowData.length > 0 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-8 mb-8"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfGrid, {
    className: "ag-theme-one",
    key: "request-header-content-1"
  }, /*#__PURE__*/_react.default.createElement(_agGridReact.AgGridReact, {
    rowClass: 'w-full',
    ref: gridApiRef,
    rowData: headersTabRowData,
    rowStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    gridOptions: {
      groupDisplayType: 'groupRows',
      suppressRowHoverHighlight: true
    },
    columnDefs: headersTabColumnDefs,
    defaultColDef: defaultColDef,
    rowHeight: 50,
    headerHeight: 50,
    domLayout: "autoHeight",
    autoSizeAllColumns: true,
    onFirstDataRendered: _grid.onFirstDataRendered.bind(this)
  })))), parametersTabValue === requestSectionTabValue && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-03 font-bold mt-4 mb-4"
  }, "Required"), /*#__PURE__*/_react.default.createElement("div", null, handleEmptyState(parametersTabValue, parametersTabRequiredRowData, 'required parameters', customClassNamesRequestTab)), parametersTabValue === requestSectionTabValue && parametersTabRequiredRowData.length > 0 && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfGrid, {
    className: "ag-theme-one",
    style: {
      height: '100%'
    },
    key: "request-parameter-required-content-1"
  }, /*#__PURE__*/_react.default.createElement(_agGridReact.AgGridReact, {
    ref: gridParamApiRef,
    rowData: parametersTabRequiredRowData,
    rowStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    gridOptions: {
      suppressRowHoverHighlight: true
    },
    columnDefs: parametersTabColumnDefs,
    defaultColDef: defaultColDef,
    headerHeight: 50,
    domLayout: "autoHeight",
    autoSizeAllColumns: true,
    onFirstDataRendered: _grid.onFirstDataRendered.bind(this)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-8 mb-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-03 font-bold mt-4 mb-4"
  }, "Optional"), /*#__PURE__*/_react.default.createElement("div", null, handleEmptyState(parametersTabValue, parametersTabOptionalRowData, 'optional parameters', customClassNamesRequestTab)), parametersTabValue === requestSectionTabValue && parametersTabOptionalRowData.length > 0 && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfGrid, {
    className: "ag-theme-one",
    style: {
      height: '100%'
    },
    key: "request-parameter-optional-content-1"
  }, /*#__PURE__*/_react.default.createElement(_agGridReact.AgGridReact, {
    ref: gridParamApiRef,
    rowData: parametersTabOptionalRowData,
    rowStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    gridOptions: {
      suppressRowHoverHighlight: true
    },
    columnDefs: parametersTabColumnDefs,
    defaultColDef: defaultColDef,
    headerHeight: 50,
    domLayout: "autoHeight",
    autoSizeAllColumns: true,
    onFirstDataRendered: _grid.onFirstDataRendered.bind(this)
  })))), /*#__PURE__*/_react.default.createElement("div", null, handleEmptyState(previewTabValue, previewTabData, 'preview')), previewTabValue === requestSectionTabValue && previewTabData !== '' && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-8 bg-action-default-900 rounded-xl h-auto"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "h-auto p-5 m-5 bg-action-default-900 display-content-operations"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-end bg-action-default-900"
  }, /*#__PURE__*/_react.default.createElement(_copyButton.default, {
    text: previewTabData,
    style: {
      color: "#FFF"
    }
  }, "Copied")), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBox, {
    className: "h-auto -mt-8 bg-action-default-900 font-mono text-sm box-spacing-default box-layout-default box-accent box-shape-rounded"
  }, /*#__PURE__*/_react.default.createElement("pre", null, /*#__PURE__*/_react.default.createElement("code", {
    className: "text-inverse-secondary"
  }, previewTabDataFormatted(previewTabData)))))))));
}